import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

const MENU_JSON = {
  de: JSON.stringify([
    {
      title: 'Vorspeisen',
      items: [
        { name: 'Burrata', price: '14', description: 'Tomaten, Basilikumöl' },
        { name: 'Carpaccio', price: '16', description: 'Rucola, Parmesan' },
      ],
    },
    {
      title: 'Hauptgänge',
      items: [
        { name: 'Branzino', price: '32', description: 'Zitrone, Kapern' },
        { name: 'Entenbrust', price: '34', description: 'Kirschen' },
      ],
    },
    {
      title: 'Desserts',
      items: [
        { name: 'Schokoladenfondant', price: '12', description: 'Vanilleeis' },
        { name: 'Zitronentarte', price: '11', description: 'Baiser, Yuzu' },
      ],
    },
  ]),
  en: JSON.stringify([
    {
      title: 'Starters',
      items: [
        { name: 'Burrata', price: '14', description: 'Heirloom tomato, basil oil' },
        { name: 'Carpaccio', price: '16', description: 'Arugula, parmesan' },
      ],
    },
    {
      title: 'Mains',
      items: [
        { name: 'Branzino', price: '32', description: 'Lemon, capers, herbs' },
        { name: 'Duck breast', price: '34', description: 'Cherry gastrique' },
      ],
    },
    {
      title: 'Desserts',
      items: [
        { name: 'Chocolate fondant', price: '12', description: 'Vanilla ice cream' },
        { name: 'Lemon tart', price: '11', description: 'Meringue, yuzu' },
      ],
    },
  ]),
  vi: JSON.stringify([
    {
      title: 'Khai vị',
      items: [
        { name: 'Burrata', price: '14', description: 'Cà chua, dầu húng quế' },
        { name: 'Carpaccio', price: '16', description: 'Rucola, parmesan' },
      ],
    },
    {
      title: 'Món chính',
      items: [
        { name: 'Branzino', price: '32', description: 'Chanh, caper, thảo mộc' },
        { name: 'Ức vịt', price: '34', description: 'Sốt cherry' },
      ],
    },
    {
      title: 'Tráng miệng',
      items: [
        { name: 'Fondant sô cô la', price: '12', description: 'Kem vani' },
        { name: 'Bánh chanh', price: '11', description: 'Meringue, yuzu' },
      ],
    },
  ]),
};

export const dynamicMenuFlowDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.dynamicMenu,
  componentType: LAYOUT_COMPONENT_TYPE.dynamicMenuFlow,
  registryBlockKey: REGISTRY_BLOCK.presentation.dynamicMenuFlow,
  displayOrder: 3,
  content: {
    sectionTitle: loc3('Saisonale Karte', 'Seasonal menu', 'Thực đơn theo mùa'),
    sectionSubtitle: loc3(
      'Nach Kategorie stöbern.',
      'Browse by category.',
      'Duyệt theo danh mục.',
    ),
    menuData: MENU_JSON,
  },
  media: {},
};
